<template>
  <div class="section total">
    <div class="header">
      <span>营收总览</span>
    </div>
    <div class="main">
      <div class="left">
        <div class="item">
          <img class="icon" src="@/assets/img/operate/xmys.png" />
          <div class="content">
            <span class="label">项目营收（万元）</span>
            <div class="value">
              <span class="yuan">¥</span>
              <span class="val">{{ formatNumber(details.planRevenueAmount) }}</span>
            </div>
          </div>
        </div>
        <div class="item">
          <img class="icon" src="@/assets/img/operate/tb.png" />
          <div class="content">
            <span class="label">同比</span>
            <div class="value">
              <span class="val">{{ details.planYoyRevenuePer ?? 100 }}%</span>
              <img v-if="details.planYoyRevenuePer > 0" src="@/assets/img/operate/up.png" />
              <img v-if="details.planYoyRevenuePer < 0" src="@/assets/img/operate/down.png" />
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="chart-item">
          <div class="chart-header">
            <span class="title"></span>
          </div>
          <div class="chart-content" id="chart1"></div>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" title="营收总览">
      <el-form inline>
        <el-form-item>
          <el-date-picker v-model="searchForm.yearMonth" type="month" value-format="yyyy-MM" placeholder="请选择年月" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loadselectRevenueMonthList">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData">
        <el-table-column prop="projectName" label="项目名称" />
        <el-table-column prop="planRevenueAmount" label="计划营收额（元）" />
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import chartMixin from '@/mixins/mixin'
export default {
  name: 'Overview1',
  mixins: [chartMixin],
  data() {
    return {
      dialogVisible: false,
      searchForm: {
        yearMonth: ''
      },
      tableData: [],
      details: {
        planRevenueAmount: '', // 营收计划金额
        planYoyRevenuePer: '', // 营收计划同比差率
        ymList: [], // 年月列表
        planRevenueAmountList: [] // 营收计划金额列表
      }
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
    this.$event.$on('yearMonthChange', this.loadData)
  },
  beforeDestroy() {
    this.$event.$off('yearMonthChange')
  },
  methods: {
    formatNumber(num) {
      // 检查输入是否为数字
      if (!num) {
        return '--'
      }
      // 除以 10000 并保留三位小数
      const result = (num / 10000).toFixed(3);
      // 返回结果（注意：toFixed 返回的是字符串，如果需要数字可以转换）
      return parseFloat(result);
    },
    loadData(searchForm) {
      this.$axios.get(this.$apis.operate.selectRevenue, searchForm).then(res => {
        this.details = res || {}
        this.initChart()
      })
    },
    loadselectRevenueMonthList() {
      const loadingInstance = this.$loading({ text: '加载中...' });
      this.$axios.get(this.$apis.operate.selectRevenueMonthList, {
        yearMonth: this.searchForm.yearMonth
      }).then(res => {
        this.tableData = res || []
        this.dialogVisible = true
      }).finally(() => {
        loadingInstance.close();
      })
    },
    initChart() {
      const chart = this.$getChartInstance('#chart1')
      if (!chart) return;
      const option = {
        tooltip: {
          formatter: (params) => {
            let tooltipStr = params.marker + ' ' + params.name + ' ' + `<span style="float:right;margin-left:20px;font-size:14px;color:#666;font-weight:900">${params.value}元</span>`
            return tooltipStr
          }
        },
        grid: {
          left: 0,
          right: 30,
          bottom: 60,
          top: 30
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          axisLabel: {
            fontSize: 14,
            color: '#333333'
          },
          data: this.details.ymList
        },
        yAxis: {
          type: 'value',
          show: false
        },
        series: [
          {
            barWidth: 40,
            data: this.details.planRevenueAmountList,
            color: '#0076FF',
            type: 'bar'
          }
        ]
      }
      chart.clear()
      chart.setOption(option)
      chart.off('click')
      chart.on('click', (params) => {
        // params 包含了点击事件的相关信息，如点击的数据项、坐标等
        console.log('点击的数据项:', params)
        this.searchForm.yearMonth = params.name
        this.loadselectRevenueMonthList(params.name)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.section {
  height: 570px;
  background: #FFFFFF;
  border-radius: 2px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;

  &.total {
    height: 392px;
    margin-top: 50px;
  }

  .header {
    height: 60px;
    border-bottom: 1px solid #E8E8E8;
    display: flex;
    align-items: center;
    padding: 0 24px;

    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      text-align: left;
      font-style: normal;
    }
  }

  .main {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 0 60px;

    .left {
      display: flex;
      flex-direction: column;

      .item {
        display: flex;

        &:nth-child(n + 2) {
          margin-top: 30px;
        }

        .icon {
          width: 24px;
          height: 24px;
          margin-right: 16px;
        }

        .content {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;

          .label {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #7F8FA4;
            line-height: 24px;
            text-align: left;
            font-style: normal;
          }

          .value {
            display: flex;
            align-items: flex-end;
            align-items: center;
            margin-top: 16px;

            span {
              &.yuan {
                font-size: 20px;
                margin-right: 10px;
                line-height: 32px;
              }

              &.val {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 24px;
                color: #354052;
                line-height: 32px;
                text-align: left;
                font-style: normal;
              }
            }

            img {
              width: 15px;
              height: 18px;
              margin-left: 10px;
            }
          }

          .desc {
            display: flex;
            align-items: center;
            margin-top: 20px;

            span {
              &:nth-child(1) {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #7F8FA4;
                line-height: 24px;
                text-align: left;
                font-style: normal;
              }

              &:nth-child(2) {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #354052;
                line-height: 24px;
                text-align: left;
                font-style: normal;
                margin-left: 10px;
              }
            }

            img {
              width: 15px;
              height: 18px;
              margin-left: 10px;
            }
          }
        }
      }
    }

    .right {
      flex: 1;
      display: flex;
      align-items: center;
      height: 100%;
      margin-left: 90px;

      .chart-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        height: 100%;

        .chart-header {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .title {}
        }

        .chart-content {
          flex: 1;
        }
      }
    }
  }
}
</style>
